module.exports = __webpack_public_path__ + "img/Payment_Classic.a07096be.png";